module.exports = __webpack_public_path__ + "static/media/allBrands.9d8cd14b.webp";